import { Component, OnInit } from '@angular/core';
import { NavController, NavParams, ToastController, ViewController, ModalController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { OrdersCoServices } from '../../../orders/services';
import { TranslateService } from '@ngx-translate/core';
import { TakeawayServices } from '../../../takeaway/services';
import { TPVServices } from '../../../tpv/services';
import { PosElementPersonPage } from '../pos-element-person/pos-element-person';
import { ComboServices } from '../../../combo/services';

/**
 * Generated class for the  page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-pos-combo',
  templateUrl: 'pos-combo.html',
})
export class PosComboPage implements OnInit {

  origin: string;
  combo: any;
  person: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public ordersCoServices: OrdersCoServices,
    public translate: TranslateService,
    public toastCtrl: ToastController,
    public takeawayServices: TakeawayServices,
    public tpvServices: TPVServices,
    public viewCtrl: ViewController,
    public modalCtrl: ModalController,
    public comboServices: ComboServices,
  ) {

  }

  ngOnInit() {
    this.origin = this.navParams.get('origin');
    this.combo = this.navParams.get('combo');
    this.combo.price_with_extras = this.combo.price;
  }

  save() {
    //miramos si podemos insertar el combo (cumple con lo obligatorio?)
    var _ret = this.checkComboOKToInsert();
    var n_combos = 0;

    if (!this.globals.checkLimitsByLicense('daily_menu', 'suplements')) {
      this.combo.price_with_extras = this.combo.price;
    }
    //caso todo ok 
    if (_ret) {
      if (this.origin == 'tpv') {
        if (this.combo.price_with_extras != this.combo.price) {
          this.tpvServices.insertTable(this.comboServices.comboTitleByLang(this.combo) + ' - ' + this.combo.price_with_extras, this.combo.price_with_extras, false, true, 'combo', this.combo.UID, this.combo);
        } else {
          this.tpvServices.insertTable(this.comboServices.comboTitleByLang(this.combo), this.combo.price_with_extras, false, true, 'combo', this.combo.UID, this.combo);
        }
        this.tpvServices.autoScrollEnterElements();
      } else if (this.origin == 'comandero') {

        n_combos = this.countCombosInOrder();
        this.insertComboInComandero(n_combos, 1);


      } else if (this.origin == 'tk') {
        n_combos = this.countCombosInTK();

        this.insertComboInTK(n_combos);
      } else if (this.origin == 'simulator') {

        this.insertComboInSimulator();
      }


      this.cleanMenu();
      this.viewCtrl.dismiss();
    }

  }

  cancel() {
    this.cleanMenu();
    this.viewCtrl.dismiss();
  }
  close() {
    this.cleanMenu();
    this.viewCtrl.dismiss();
  }

  ionViewWillLeave() {
    this.cleanMenu();

  }

  cleanMenu() {
    for (let section of this.globals.objectToArray(this.combo.sections)) {
      if (section.selected) {
        section.selected = '';
      }
      //
      for (let dish of this.globals.objectToArray(section.dish)) {
        if (dish.active) {
          dish.active = false;
        }
      }
    }
  }

  checkComboOKToInsert() {
    var _ret = true;
    //
    for (let section of this.globals.objectToArray(this.combo.sections)) {
      //
      var dish_required = false;
      var _price_with_extras = 0;
      for (let dish of this.globals.objectToArray(section.dish)) {
        //miramos si hay algun plato activo (caso activo quiere decir que cumplimos con que hay 1 seleccionado en el apartado)
        if (dish.active == true) {
          dish_required = true;
        }
        //miramos los extras
        if (section.combo_cost_extra == true && (dish.active == true || (section.selected != undefined || section.selected != ''))) {


          if (dish.active) {
            _price_with_extras += dish.price_combo_extra;
          }

          if (section.selected) {
            var s_e = section.selected.split("-");
            if (this.globals.nameLangSelectProduct(dish) == this.globals.nameLangSelectProduct(this.globals.objectToArray(section.dish)[s_e[1]])) {
              _price_with_extras += dish.price_combo_extra;
            }
          }

        }

      }
      this.combo.price_with_extras += _price_with_extras;
      //
      if (section.combo_required == true && (dish_required == true || (section.selected != undefined && section.selected != ''))) {
      } else if (section.combo_required == undefined || section.combo_required == false) {
      } else {
        this.launchToast(section.name);
        _ret = false;
      }
    }
    return _ret;
  }

  launchToast(name) {
    let toast = this.toastCtrl.create({
      message: this.translate.instant('instant-la-seccion') + name + this.translate.instant('instant-es-obligatoria'),
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }

  countCombosInOrder() {
    var n_combos = 0;
    for (let section of this.globals.objectToArray(this.ordersCoServices.order_tmp)) {
      for (let element of this.globals.objectToArray(section.list)) {
        if (element.type == 'combo') {
          n_combos++;
        }
      }
    }
    return n_combos;
  }

  countCombosInTK() {
    var n_combos = 0;
    for (let section of this.globals.objectToArray(this.takeawayServices.order_tmp)) {
      for (let element of this.globals.objectToArray(section.list)) {
        if (element.type == 'combo') {
          n_combos++;
        }
      }
    }
    return n_combos;
  }

  insertComboInComandero(n_combos, data) {

    //insert combo
    if (this.combo.price_with_extras != this.combo.price) {
      this.insertTable(this.comboServices.comboTitleByLang(this.combo) + ' - ' + this.combo.price_with_extras, this.combo.price_with_extras, false, true, 'combo', this.combo.UID, 'Menu', this.combo.UID, n_combos, this.combo);
    } else {
      this.insertTable(this.comboServices.comboTitleByLang(this.combo), this.combo.price_with_extras, false, true, 'combo', this.combo.UID, 'Menu', this.combo.UID, n_combos, this.combo);
    }
    this.ordersCoServices.count_elements++;//insert ++
    //insert elements of combo
    for (let section of this.globals.objectToArray(this.combo.sections)) {
      //caso select
      if (section.selected != undefined && section.selected != '') {
        var s_e = section.selected.split("-");
        var i_section = s_e[0];
        var i_element = s_e[1];
        if (this.combo.sections[i_section].dish[i_element].type == 'dish') {
          this.insertTable(this.tpvServices.nameLangSelectMenuDish(this.globals.restaurant.lang, this.combo.sections[i_section].dish[i_element]), 0, false, true, this.combo.sections[i_section].dish[i_element].type, this.combo.sections[i_section].dish[i_element].uid, section.name, this.combo.UID, n_combos, this.combo.sections[i_section].dish[i_element]);
        } else if (this.combo.sections[i_section].dish[i_element].type == 'product') {
          this.insertTable(this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, this.combo.sections[i_section].dish[i_element]), 0, false, true, this.combo.sections[i_section].dish[i_element].type, this.combo.sections[i_section].dish[i_element].uid, section.name, this.combo.UID, n_combos, this.combo.sections[i_section].dish[i_element]);
        }
      }
      for (let element of this.globals.objectToArray(section.dish)) {
        //caso checkbox
        if (element.active == true) {
          if (element.type == 'dish') {
            this.insertTable(this.tpvServices.nameLangSelectMenuDish(this.globals.restaurant.lang, element), 0, false, true, element.type, element.uid, section.name, this.combo.UID, n_combos, element);
          } else if (element.type == 'product') {
            this.insertTable(this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, element), 0, false, true, element.type, element.uid, section.name, this.combo.UID, n_combos, element);
          }
        }
      }
    }

  }

  insertComboInTK(n_combos) {
    //insert combo
    if (this.combo.price_with_extras != this.combo.price) {
      this.insertTableTK(this.comboServices.comboTitleByLang(this.combo) + ' - ' + this.combo.price_with_extras, this.combo.price_with_extras, false, true, 'combo', this.combo.UID, 'Menu', this.combo.UID, n_combos, this.combo);
    } else {
      this.insertTableTK(this.comboServices.comboTitleByLang(this.combo), this.combo.price_with_extras, false, true, 'combo', this.combo.UID, 'Menu', this.combo.UID, n_combos, this.combo);
    }
    //insert elements of combo
    for (let section of this.globals.objectToArray(this.combo.sections)) {
      //caso select
      if (section.selected != undefined && section.selected != '') {
        var s_e = section.selected.split("-");
        var i_section = s_e[0];
        var i_element = s_e[1];
        if (this.combo.sections[i_section].dish[i_element].type == 'dish') {
          this.insertTableTK(this.tpvServices.nameLangSelectMenuDish(this.globals.restaurant.lang, this.combo.sections[i_section].dish[i_element]), 0, false, true, this.combo.sections[i_section].dish[i_element].type, this.combo.sections[i_section].dish[i_element].uid, section.name, this.combo.UID, n_combos, this.combo.sections[i_section].dish[i_element]);
        } else if (this.combo.sections[i_section].dish[i_element].type == 'product') {
          this.insertTableTK(this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, this.combo.sections[i_section].dish[i_element]), 0, false, true, this.combo.sections[i_section].dish[i_element].type, this.combo.sections[i_section].dish[i_element].uid, section.name, this.combo.UID, n_combos, this.combo.sections[i_section].dish[i_element]);
        }
      }
      for (let element of this.globals.objectToArray(section.dish)) {
        //caso checkbox
        if (element.active == true) {
          if (element.type == 'dish') {
            this.insertTableTK(this.tpvServices.nameLangSelectMenuDish(this.globals.restaurant.lang, element), 0, false, true, element.type, element.uid, section.name, this.combo.UID, n_combos, element);
          } else if (element.type == 'product') {
            this.insertTableTK(this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, element), 0, false, true, element.type, element.uid, section.name, this.combo.UID, n_combos, element);
          }
        }
      }
    }
  }




  /*SERVICES DE COMANDERO ADAPTADOS*/
  //para pooder añadir la uid del combo y una id temporal al elemento
  insertTable(_name, _price, _delete, _count, _type, _uid, sec, _uid_combo, _uid_combo_tmp, _element) {

    if (this.globals.ordersPersonsElements('order')) {//caso abrir comensale elemento

      if (_type == 'combo') {//caso combo solo pregunta en el elemento princpal que es combo
        let profileModal = this.modalCtrl.create(PosElementPersonPage,
          {
            title: _name,
            number_persons: this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].persons,
          });
        profileModal.onDidDismiss(data => {

          this.person = data;
          //check price
          if (_price == undefined) {
            _price = 0;
          }
          //check tags
          if (_element.tags == undefined) {
            _element.tags = [];
          }
          //check type_unit
          if (_element.type_unit == undefined) {
            _element.type_unit = 'ud';
          }
          //check tax
          if (_element.tax == undefined) {
            _element.tax = parseFloat(this.globals.user_tax);
          }
          //create object
          var obj_mod = {
            count: _count,
            delete: _delete,
            name: _name,
            price: _price,
            tax: _element.tax,
            type: _type,
            uid_element: _uid,
            uid_element_combo: _uid_combo,
            uid_combo_tmp: _uid_combo_tmp++,
            units: 1,
            change: '',
            finish: '',
            state: 'normal',
            variations: [],
            person: this.person,
            tags: _element.tags,
            type_unit: _element.type_unit
          }
          var _combo_section = true;
          if (_type == 'combo') {
            _combo_section = false;
          }

          //modificacio
          var section = {};
          if (this.ordersCoServices.update_state) {
            if (Object.keys(this.ordersCoServices.order_tmp).length == 0) {
              section = {
                name: sec,
                only_combo: _combo_section,
                list: {
                  0: obj_mod,

                },
              }
              this.ordersCoServices.order_tmp.push(section);

            }
          } else {
            var index_combo = this.ordersCoServices.order_tmp.findIndex(x => x.name == sec);
            if (index_combo >= 0) {
              //this.order_tmp[index].list.push(list);
              var last_key_mod = Object.keys(this.ordersCoServices.order_tmp[index_combo].list)[Object.keys(this.ordersCoServices.order_tmp[index_combo].list).length - 1]; //get the last key in the object
              if (last_key_mod == undefined) {
                last_key_mod = '-1';//Iniciamos a 0 si esta undefined
              }

              this.ordersCoServices.order_tmp[index_combo].list[Number(last_key_mod) + 1] = obj_mod;

            } else {
              section = {
                name: sec,
                only_combo: _combo_section,
                list: {
                  0: obj_mod,
                },
              }
              this.ordersCoServices.order_tmp.push(section);
            }
          }

          //data set waiter activity
          var extra_activity_mod: any =
          {
            'type': 'add',
            'value': 1,
            'source': 'orders',

          };
          this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity_mod), '');

        });
        profileModal.present();
      } else {//caso elementos del combo
        //check price
        if (_price == undefined) {
          _price = 0;
        }
        //check tags
        if (_element.tags == undefined) {
          _element.tags = [];
        }
        //check type_unit
        if (_element.type_unit == undefined) {
          _element.type_unit = 'ud';
        }
        //check tax
        if (_element.tax == undefined) {
          _element.tax = parseFloat(this.globals.user_tax);
        }
        //create object
        var obj_combo = {
          count: _count,
          delete: _delete,
          name: _name,
          price: _price,
          tax: _element.tax,
          type: _type,
          uid_element: _uid,
          uid_element_combo: _uid_combo,
          uid_combo_tmp: _uid_combo_tmp++,
          units: 1,
          change: '',
          finish: '',
          state: 'normal',
          variations: [],
          person: this.person,
          tags: _element.tags,
          type_unit: _element.type_unit
        }

        var _combo_section_combo = true;
        if (_type == 'combo') {
          _combo_section_combo = false;
        }

        //modificacio
        var section_mod = {};
        if (this.ordersCoServices.update_state) {
          if (Object.keys(this.ordersCoServices.order_tmp).length == 0) {
            section_mod = {
              name: sec,
              only_combo: _combo_section_combo,
              list: {
                0: obj_combo,

              },
            }
            this.ordersCoServices.order_tmp.push(section_mod);

          }
        } else {
          var index_combo_elements = this.ordersCoServices.order_tmp.findIndex(x => x.name == sec);
          if (index_combo_elements >= 0) {
            //this.order_tmp[index].list.push(list);
            var last_key_combo = Object.keys(this.ordersCoServices.order_tmp[index_combo_elements].list)[Object.keys(this.ordersCoServices.order_tmp[index_combo_elements].list).length - 1]; //get the last key in the object
            if (last_key_combo == undefined) {
              last_key_combo = '-1';//Iniciamos a 0 si esta undefined
            }

            this.ordersCoServices.order_tmp[index_combo_elements].list[Number(last_key_combo) + 1] = obj_combo;

          } else {
            section_mod = {
              name: sec,
              only_combo: _combo_section_combo,
              list: {
                0: obj_combo,
              },
            }
            this.ordersCoServices.order_tmp.push(section_mod);
          }
        }

        //data set waiter activity
        var extra_activity_combo: any =
        {
          'type': 'add',
          'value': 1,
          'source': 'orders',

        };
        this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity_combo), '');
      }
    } else {//caso no activado comensal elemento
      //price
      if (_price == undefined) {
        _price = 0;
      }
      //check tags
      if (_element.tags == undefined) {
        _element.tags = [];
      }
      //check type_unit
      if (_element.type_unit == undefined) {
        _element.type_unit = 'ud';
      }
      //check tax
      if (_element.tax == undefined) {
        _element.tax = parseFloat(this.globals.user_tax);
      }
      //create object
      var obj = {
        count: _count,
        delete: _delete,
        name: _name,
        price: _price,
        tax: _element.tax,
        type: _type,
        uid_element: _uid,
        uid_element_combo: _uid_combo,
        uid_combo_tmp: _uid_combo_tmp++,
        units: 1,
        change: '',
        finish: '',
        state: 'normal',
        variations: [],
        person: null,
        tags: _element.tags,
        type_unit: _element.type_unit
      }
      var _combo_section = true;
      if (_type == 'combo') {
        _combo_section = false;
      }

      //modificacio
      var section = {};
      if (this.ordersCoServices.update_state) {
        if (Object.keys(this.ordersCoServices.order_tmp).length == 0) {
          section = {
            name: sec,
            only_combo: _combo_section,
            list: {
              0: obj,

            },
          }
          this.ordersCoServices.order_tmp.push(section);

        }
      } else {
        var index = this.ordersCoServices.order_tmp.findIndex(x => x.name == sec);
        if (index >= 0) {
          //this.order_tmp[index].list.push(list);
          var last_key = Object.keys(this.ordersCoServices.order_tmp[index].list)[Object.keys(this.ordersCoServices.order_tmp[index].list).length - 1]; //get the last key in the object
          if (last_key == undefined) {
            last_key = '-1';//Iniciamos a 0 si esta undefined
          }

          this.ordersCoServices.order_tmp[index].list[Number(last_key) + 1] = obj;

        } else {
          section = {
            name: sec,
            only_combo: _combo_section,
            list: {
              0: obj,
            },
          }
          this.ordersCoServices.order_tmp.push(section);
        }
      }

      //data set waiter activity
      var extra_activity: any =
      {
        'type': 'add',
        'value': 1,
        'source': 'orders',

      };
      this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');
    }


  }

  //Inserta un elemento en una mesa
  insertTableTK(_name, _price, _delete, _count, _type, _uid, sec, _uid_combo, _uid_combo_tmp, _element) {
    //check price
    if (_price == undefined) {
      _price = 0;
    }
    //check tags
    if (_element.tags == undefined) {
      _element.tags = [];
    }
    //check type_unit
    if (_element.type_unit == undefined) {
      _element.type_unit = 'ud';
    }
    //check tax
    if (_element.tax == undefined) {
      _element.tax = parseFloat(this.globals.user_tax);
    }
    //create object
    var obj = {
      count: _count,
      delete: _delete,
      name: _name,
      price: _price,
      tax: _element.tax,
      type: _type,
      uid_element: _uid,
      uid_element_combo: _uid_combo,
      uid_combo_tmp: _uid_combo_tmp++,
      units: 1,
      change: '',
      finish: '',
      state: 'normal',
      variations: [],
      tags: _element.tags,
      type_unit: _element.type_unit
    }
    var _combo_section = true;
    if (_type == 'combo') {
      _combo_section = false;
    }

    //modificacio
    var section = {};
    if (this.takeawayServices.update_state) {
      if (Object.keys(this.takeawayServices.order_tmp).length == 0) {
        section = {
          name: sec,
          only_combo: _combo_section,
          list: {
            0: obj,

          },
        }
        this.takeawayServices.order_tmp.push(section);

      }
    } else {
      var index = this.takeawayServices.order_tmp.findIndex(x => x.name == sec);

      if (index >= 0) {
        //this.order_tmp[index].list.push(list);
        var last_key = Object.keys(this.takeawayServices.order_tmp[index].list)[Object.keys(this.takeawayServices.order_tmp[index].list).length - 1]; //get the last key in the object
        if (last_key == undefined) {
          last_key = '-1';//Iniciamos a 0 si esta undefined
        }

        this.takeawayServices.order_tmp[index].list[Number(last_key) + 1] = obj;

      } else {
        section = {
          name: sec,
          only_combo: _combo_section,
          list: {
            0: obj,
          },
        }
        this.takeawayServices.order_tmp.push(section);
      }
    }
    //data set waiter activity
    var extra_activity: any =
    {
      'type': 'add',
      'value': 1,
      'source': 'takeaway',

    };
    this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');
  }


  insertComboInSimulator() {

    var total_price = 0;
    var total_foodcost = 0;
    let list = [];

    //insert combo
    if (this.combo.price_with_extras != this.combo.price) {
      total_price = this.combo.price_with_extras
    } else {
      total_price = this.combo.price
    }
    //insert elements of combo
    for (let section of this.globals.objectToArray(this.combo.sections)) {
      //caso select
      if (section.selected != undefined && section.selected != '') {
        var s_e = section.selected.split("-");
        var i_section = s_e[0];
        var i_element = s_e[1];
        var name_element = "";
        var foodcost_combo = 0;

        if (this.combo.sections[i_section].dish[i_element].type == 'dish') {
          name_element = this.tpvServices.nameLangSelectMenuDish(this.globals.restaurant.lang, this.combo.sections[i_section].dish[i_element])
        } else if (this.combo.sections[i_section].dish[i_element].type == 'product') {
          name_element = this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, this.combo.sections[i_section].dish[i_element])
        }
        if (this.combo.sections[i_section].dish[i_element].foodcost_static != undefined && this.combo.sections[i_section].dish[i_element].foodcost_parts != undefined && this.combo.sections[i_section].dish[i_element].foodcost_static && this.combo.sections[i_section].dish[i_element].foodcost_parts) {
          foodcost_combo += (this.combo.sections[i_section].dish[i_element].foodcost_static / parseFloat(this.combo.sections[i_section].dish[i_element].foodcost_parts));
          total_foodcost += foodcost_combo;
        }

        _element = {
          "name": name_element,//
          "section_name": section.name,
          "foodcost": foodcost_combo,//foodcost
        };
        list.push(_element);

      }
      for (let element of this.globals.objectToArray(section.dish)) {
        //caso checkbox
        if (element.active == true) {
          name_element = "";
          var foodcost = 0;
          if (element.type == 'dish') {
            name_element = this.tpvServices.nameLangSelectMenuDish(this.globals.restaurant.lang, element);
          } else if (element.type == 'product') {
            name_element = this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, element);
          }
          if (element.foodcost_static != undefined && element.foodcost_parts != undefined && element.foodcost_static && element.foodcost_parts) {
            foodcost = (element.foodcost_static / parseFloat(element.foodcost_parts));
            total_foodcost += foodcost;
          }
          var _element = {
            "name": name_element,//
            "section_name": section.name,
            "foodcost": foodcost,//foodcost
          };
          list.push(_element);
        }
      }
    }

    var combo = {
      "name": this.tpvServices.nameMenuLangSelect(this.globals.restaurant.lang, this.combo),
      "list": list,
      "price": total_price,//precio 
      "foodcost": total_foodcost,//foodcost
    };

    this.comboServices.addComboInSimulator(combo);
  }


}



// WEBPACK FOOTER //
// ./src/pages/components/pos/pos-combo/pos-combo.ts